import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import EventLabel from '../../../components/EventLabel/EventLabel';

export const GLNPopup = ({ onSuccess, list }) => {
  const handleCancel = () => onSuccess(-1);
  const handleChange = (e, value) => (value != null ? onSuccess(value) : onSuccess(null));

  //need to disable maxWidth on form-dialog-title
  return (
    <Dialog open={true} aria-labelledby="form-dialog-title" style={{ maxWidth: 'none' }}>
      <DialogTitle id="form-dialog-title">
        <EventLabel name="SelectCompany" groupName="CMS.Payment" />
      </DialogTitle>
      <DialogContent>
        {list?.map(({ name, gln, companyId, ...rest }) => (
          <MenuItem key={companyId} onClick={e => handleChange(e, { gln, name, ...rest })} value={{ name, gln }} style={{ width: '100%' }}>
            <ul name={'left'} className="cms-invoice-gln-left" style={{ paddingInlineStart: '0%', whiteSpace: 'pre-wrap' }}>
              {name}
            </ul>
            <ul name={'right'} className="cms-invoice-gln-right" style={{ flex: 'auto', textAlign: 'right' }}>
              {gln}
            </ul>
          </MenuItem>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          <EventLabel name="Cancel" groupName="CMS.Payment" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
